import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-report-output-header',
    styleUrls: ['./report-output-header.component.scss'],
    templateUrl: './report-output-header.component.html',
    standalone: false
})
export class ReportOutputHeaderComponent {
   @Input() subTitle: string;
}
